var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import qs from 'qs';
export const getCSRFToken = () => {
    var _a;
    return (_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content');
};
const BASE_URL = 'https://matching.itonami.design';
// const BASE_URL = 'http://localhost';
const requestInit = {
    method: 'GET',
    cache: 'no-cache',
    headers: {
        Accept: 'application/json',
        'X-CSRF-Token': (_a = getCSRFToken()) !== null && _a !== void 0 ? _a : ''
    }
};
export function fetchData(obj) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const endpoint = obj.endpoint, params = obj.params, options = obj.options, _obj$isFormdata = obj.isFormdata, isFormdata = _obj$isFormdata === void 0 ? false : _obj$isFormdata;
            const path = [`${BASE_URL}${endpoint}`, qs.stringify(params)].join('?');
            const headers = _objectSpread({}, isFormdata ? {} : {
                'Content-Type': 'application/json'
            });
            const res = yield fetch(path, _objectSpread(_objectSpread(_objectSpread({}, requestInit), options), {}, {
                headers
            }));
            const json = yield res.json();
            return _objectSpread(_objectSpread({}, json), {}, {
                statusCode: res.status
            });
        }
        catch (error) {
            return {
                success: false,
                message: error.message,
                errors: null,
                data: null,
                statusCode: 500
            };
        }
    });
}
